// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__27KUI","toggle":"styles_toggle__wT6Xf","preview":"styles_preview__1W5W-"};